import IconAsMaskImage from '../IconAsMaskImage'

function SmilingFace({ pureSvg, className, color, ...rest }) {
  const svg = (
    <svg {...rest} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 15.75C12.7282 15.75 15.75 12.7274 15.75 9C15.75 5.27181 12.7282 2.25 9 2.25C5.27181 2.25 2.25 5.27181 2.25 9C2.25 12.7274 5.27181 15.75 9 15.75Z"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.08789 7.35709C6.28638 7.09877 6.579 6.9375 6.90373 6.9375C7.22845 6.9375 7.52107 7.09877 7.7196 7.35709"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1895 7.35709C10.388 7.09877 10.6806 6.9375 11.0053 6.9375C11.3301 6.9375 11.6227 7.09877 11.8212 7.35709"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83984 10.7168C7.36598 11.4012 8.14025 11.8281 8.99983 11.8281C9.85948 11.8281 10.6345 11.4012 11.1598 10.7168"
        stroke="black"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, color }} />
}

export default SmilingFace
